module.exports = __webpack_public_path__ + "img/export-icon-green.dc9da0a3.svg";